/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.17.0
 */

import styled from 'styled-components';

import { globalThemeConstants } from '../../../theme';

export const CorporatePagePortalStyled = styled.div.attrs({
    className: 'corporate-page-portal',
})`
    width: 100%;
    max-width: ${globalThemeConstants.maxSiteWidth};
    min-width: ${globalThemeConstants.minSiteWidth};
    margin: 0 auto;
`;
